import { makeAutoObservable } from "mobx";
import {
	addNewRecommend,
	fetchMoneyDetails,
	getCbaseCoinSymbolList,
	getCommissionDetailList,
	getCommissionDetailSummary,
	getCommissionDirector,
	getCommissionDirectorTotal,
	getDataBoardDailyData,
	getDataBoardOverview,
	getFutureTrade,
	getInvitedCodeList,
	getInvitedUserList,
	getLatestRegisterList,
	getLeftUserTreeData,
	getLevelCommissionDirector,
	getLevelCommissionDirectorTotal,
	getPartnerInfo,
	getPartnerInvitedCode,
	getPartnerList,
	getPartnerManageList,
	getPartnerRank,
	getPartnerUserList,
	getSpotTrade,
	getSymbolList,
	getUbaseCoinSymbolList,
	getUserCommissionLimit,
	getUserProfile,
	getWithdrawCoinList,
	getWithdrawList,
	updatePartner,
	updateRecommendRemark,
	updateRecommendDefault,
} from "../api/xt-console";

export const pageHashKey = 'pageHash';

export default class Console {
	loading = false;
	lang = "zh-CN";
	menuCollapsed = false;
	menuSelected = {
		key: "board",
		label: "console.menu.dataBoard",
	};
	databoardOverview = {};
	withdrawCoinList = [];
	userProfile = {};
	latestRegisterList = [];
	dailyData = {};
	withdrawHistoryList = [];
	rankList = [];
	partnerManageList = [];
	partnerInfo = {}; // 合伙人信息（更新时间和周期）
	partnerTypeList = [];
	userManageList = [];
	inviteLinkList = [];
	invitedPeopleList = [];
	symbolList = [];
	spotTradeList = [];
	futuresTradeList = [];
	leftUserTreeData = {};
	directorCommissionList = [];
	directorCommissionTotal = 0;
	directorCommissionLevelList = [];
	directorCommissionLevelTotal = 0;
	userCommissionLimit = {};
	commissionDetailSummary: any = {}; // 返佣明细汇总
	commissionDetailList: any[] = []; // 返佣明细列表
	commissionDetailHasMore: boolean = false; // 是否有更多数据
	overviewRefresh: any = undefined;
	allCoinSymbolList: any[] = [];
	moneyDetails: any = {};

	checkSpotTrade = "";
	checkFuturesTrade = "";
	partnerInviteCode = "";
	checkNoticeId = "";

	operateList = [
		{
			label: "console.moneyManage.chongzhi",
			value: 0,
		},
		{
			label: "console.moneyManage.withdraw",
			value: 1,
		},
		{
			label: "console.moneyManage.buyin",
			value: 2,
		},
		{
			label: "console.moneyManage.sellout",
			value: 3,
		},
		{
			label: "console.moneyManage.transferin",
			value: 4,
		},
		{
			label: "console.moneyManage.transferout",
			value: 5,
		},
	];

	// 交易类型1-永续合约,2-当月交割合约,3-次月交割合约,4-当季交割合约,5-次季交割合约,6-预测合约
	tradeTypeList = [
		{
			label: "console.futures",
			value: 1,
		},
		{
			label: "console.futuresCurrentMonth",
			value: 2,
		},
		{
			label: "console.futuresNextMonth",
			value: 3,
		},
		{
			label: "console.futuresCurrentQuarter",
			value: 4,
		},
		{
			label: "console.futuresNextQuarter",
			value: 5,
		},
		{
			label: "console.futuresPredictor",
			value: 6,
		},
	];

	bizTypeList = [
		{
			label: "home.agreement",
			value: 2,
		},
		{
			label: "home.spot",
			value: 1,
		},
	];

	partnerStatusList = [
		{
			value: 0,
			label: "console.normal",
		},
		{
			value: 1,
			label: "console.abidden",
		},
	];

	userTypeList = [
		{
			label: "console.peoplelist.channel",
			value: "CHANNEL",
		},
		{
			label: "console.rank.partner",
			value: "PARTNER",
		},
		{
			label: "console.board.director",
			value: "DIRECTOR",
		},
		{
			label: "console.common",
			value: "COMMON",
		},
	];

	withdrawStatusList = [
		{
			label: "console.waitApproval",
			value: 0,
		},
		{
			label: "console.waitDillivery",
			value: 1,
		},
		{
			label: "console.approvalFuse",
			value: 2,
		},
		{
			label: "console.dilliveried",
			value: 3,
		},
	];

	kycLevelList = [
		{
			label: "console.manage.colUnApproval",
			value: 0,
		},
		{
			label: "console.firstApproval",
			value: 1,
		},
		{
			label: "console.expertApproval",
			value: 2,
		},
		{
			label: "console.companyApproval",
			value: 3,
		},
	];

	constructor() {
		if (typeof window !== 'undefined') {
			const pageHash = localStorage.getItem(pageHashKey);
			if (pageHash) {
				this.menuSelected = JSON.parse(pageHash);
			}
		}

		makeAutoObservable(this, {}, { autoBind: true });
	}

	get currentMenuKey() {
		return this.menuSelected.key;
	}

	setLang(value) {
		this.lang = value;
	}

	setLoading(value) {
		this.loading = value;
	}

	setCheckSpotTrade(value) {
		this.checkSpotTrade = value;
	}

	setFuturesTrade(value) {
		this.checkFuturesTrade = value;
	}

	setMenuCollapsed(collapsed: boolean) {
		this.menuCollapsed = collapsed;
	}

	setMenuSelected(key: any) {
		this.menuSelected = key;
	}

	setOverviewRefresh() {
		this.overviewRefresh = !this.overviewRefresh;
	}

	setCheckNoticeId(value) {
		this.checkNoticeId = value;
	}

	*fetchDataboardOverview(data) {
		const result = yield getDataBoardOverview(data);

		this.databoardOverview = result;
		return result;
	}

	*fetchWithdrawCoinList(data) {
		const result = yield getWithdrawCoinList(data);

		this.withdrawCoinList = result;
		return result;
	}

	*fetchUserProfile(data) {
		const result = yield getUserProfile(data);

		this.userProfile = result;
		return result;
	}

	*fetchLatestRegisterList(data) {
		const result = yield getLatestRegisterList(data);

		this.latestRegisterList = result;
		return result;
	}

	*fetchDataboardDailyData(data, key) {
		const result = yield getDataBoardDailyData(data);

		if (key) {
			this.dailyData = {
				...this.dailyData,
				[key]: result[key],
			};
		} else {
			this.dailyData = result;
		}
		return result;
	}

	*fetchWithdrawHistoryList(data) {
		const result = yield getWithdrawList(data);

		this.withdrawHistoryList = result;
		return result;
	}

	*fetchPartnerRankList(data) {
		const result = yield getPartnerRank(data);

		this.rankList = result;
		return result;
	}

	*fetchPartnerManageList(data) {
		const result = yield getPartnerManageList(data);

		this.partnerManageList = result;
		return result;
	}

	*fetchPartnerInfo() {
		const result = yield getPartnerInfo();

		if (result && result.result) {
			this.partnerInfo = result.result;
		}
		return result;
	}

	*updatePartner(data) {
		const result = yield updatePartner(data);
		return result;
	}

	*fetchPartnerTypeList(data) {
		const result = yield getPartnerList(data);

		this.partnerTypeList = result;
		return result;
	}

	*fetchUserManageList(data) {
		const result = yield getPartnerUserList(data);

		this.userManageList = result;
		return result;
	}

	*fetchInviteLinkList(data) {
		const result = yield getInvitedCodeList(data);

		this.inviteLinkList = result;
		return result;
	}

	*fetchInvitedPeopleList(data) {
		const result = yield getInvitedUserList(data);

		this.invitedPeopleList = result;
		return result;
	}

	*createInviteCode(data) {
		const result = yield addNewRecommend(data);
		return result;
	}

	*updateInviteCodeRemark(id, data) {
		const result = yield updateRecommendRemark(id, data);
		return result;
	}

	*setInviteCodeDefault(id) {
		const result = yield updateRecommendDefault(id);
		return result;
	}

	*fetchSymbolList(data) {
		const result = yield getSymbolList(data);

		this.symbolList = result;
		return result;
	}

	*fetchSpotTradeList(data) {
		const result = yield getSpotTrade(data);

		this.spotTradeList = result;
		return result;
	}

	*fetchFuturesTradeList(data) {
		const result = yield getFutureTrade(data);

		this.futuresTradeList = result;
		return result;
	}

	*fetchLeftUserTreeData(data) {
		const result = yield getLeftUserTreeData(data);

		this.leftUserTreeData = result;
		return result;
	}

	*fetchDirectorCommissionList(data) {
		const result = yield getCommissionDirector(data);

		this.directorCommissionList = result;
		return result;
	}

	*fetchDirectorCommissionTotal(data) {
		const result = yield getCommissionDirectorTotal(data);

		this.directorCommissionTotal = result;
		return result;
	}

	*fetchLevelDirectorCommissionList(data) {
		const result = yield getLevelCommissionDirector(data);

		this.directorCommissionLevelList = result;
		return result;
	}

	*fetchLevelDirectorCommissionTotal(data) {
		const result = yield getLevelCommissionDirectorTotal(data);

		this.directorCommissionLevelTotal = result;
		return result;
	}

	*fetchUserCommissionLimit(data) {
		const result = yield getUserCommissionLimit(data);

		this.userCommissionLimit = result;
		return result;
	}

	*fetchAllCoinSymbolList() {
		const [ubaseList, cbaseList] = yield Promise.all([
			getUbaseCoinSymbolList(),
			getCbaseCoinSymbolList(),
		]);

		if (Array.isArray(ubaseList) && Array.isArray(cbaseList)) {
			this.allCoinSymbolList = [...ubaseList, ...cbaseList];
		}
	}

	*fetchPartnerInviteCode(data) {
		const result = yield getPartnerInvitedCode(data);

		this.partnerInviteCode = result?.inviteCode;
	}

	*fetchMoneyDetails(data) {
		const result = yield fetchMoneyDetails(data);

		this.moneyDetails = result;
	}

	*fetchCommissionDetailSummary(data) {
		const result = yield getCommissionDetailSummary(data);
		
		this.commissionDetailSummary = result
	}

	*fetchCommissionDetailList(data) {
		const result = yield getCommissionDetailList(data);

		// 根据 fromId 是否存在判断是初始加载还是分页加载
		const isInitial = !data?.fromId;

		// 直接使用 result，API 已经返回了 result.result 这一层的数据
		if (result) {
			const items = result.items || [];
			const hasNext = result.hasNext || false;

			if (isInitial) {
				// 初始加载：直接覆盖
				this.commissionDetailList = items;
			} else {
				// 分页加载：追加数据，即使 items 为空也不重置已有数据
				if (items.length > 0) {
					this.commissionDetailList = [...this.commissionDetailList, ...items];
				}
			}
			this.commissionDetailHasMore = hasNext;
		} else {
			// 接口返回错误或空数据
			if (isInitial) {
				// 只有初始加载时才重置为空数组
				this.commissionDetailList = [];
			}
			// 分页加载时，如果接口返回错误，不重置已有数据，只更新 hasMore
			this.commissionDetailHasMore = false;
		}
		return result;
	}
}
